const selectSplashElement = (
    splashNodeOrClassName:
        | HTMLElement
        | string
        | null
        | undefined = '.bootstrap-splash',
) => {
    let splashElement: HTMLElement | null = null;

    if (typeof splashNodeOrClassName === 'string') {
        // classname of the element was passed
        splashElement = document.querySelector(splashNodeOrClassName);
    } else if (splashNodeOrClassName) {
        // element was passed as a node element
        splashElement = splashNodeOrClassName;
    }

    return splashElement || null;
};

const removeWithFadeOut = (element: HTMLElement, speed: number) => {
    const TRANSITION_FACTOR_MS = 1000;
    const seconds = speed / TRANSITION_FACTOR_MS;
    element.style.transition = [
        'opacity',
        `${seconds.toString()}s`,
        'ease',
    ].join(' ');
    element.style.opacity = '0';
    setTimeout(() => {
        if (element.parentNode) {
            element.parentNode.removeChild(element);
        }
    }, speed);
};

const removeSplashAndStyles = (
    splashNodeOrClassName?: HTMLElement | string | null,
) => {
    const FADE_OUT_TIME_MS = 500;
    const splashElement = selectSplashElement(splashNodeOrClassName);

    if (splashElement?.parentNode) {
        removeWithFadeOut(splashElement, FADE_OUT_TIME_MS);
    }
};

const hideSplashAndStyles = (
    splashNodeOrClassName?: HTMLElement | string | null,
) => {
    const splashElement = selectSplashElement(splashNodeOrClassName);

    if (splashElement?.parentNode) {
        splashElement.style.display = 'none';
    }
};

export { removeSplashAndStyles, hideSplashAndStyles };
